import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1>No Match Route!!!</h1>
        </div>
    );
};

export default NotFound;